export const FINGER_PRINT_TOKEN = 'egjygTjQAUvTA2OCRyQg';
export const GUEST_TOKEN = 'guestToken';
export const REFEREE = 'referee';
export const REFERRER = 'referrer';
export const REFERRAL_DISCOUNT_EXPIRY = 'referralDiscountExpiry';
export const BOT_GUEST_TOKEN = 'bot_e150a85711e9a4028141f97a2ff1';

//TODO: Revisit to make country and translation dynamic.
export const SUBSCRIPTION_BANNER_REQUEST_PARAM = {
  id: '0-8-7497',
  page: 1,
  limit: 12,
  country: 'IN',
  translation: 'en'
};

// Asset type
export enum ASSET_TYPE {
  Movie = 0,
  Episode = 1,
  Season = 2,
  Album = 3,
  ContentSet = 4,
  Track = 5,
  TvShow = 6,
  Collection = 8,
  Channel = 9,
  EpgProgram = 10,
  SubscriptionPlan = 11,
  Notification = 12,
  PromoCode = 13,
  LiveEvent = 14,
  File = 15,
  GenreList = 16,
  Unknown = 99,
  Custom = 100
}

export enum BUSINESS_TYPE {
  TVOD = 'tvod',
  TVOD_DOWNLOADABLE = 'tvod_downloadable',
  TVOD_PREMIUM = 'tvod_premium',
  SVOD = 'SVOD',
  RSVOD = 'RSVOD',
  PREMIUM = 'premium',
  PREMIUM_DOWNLOADABLE = 'premium_downloadable',
  ADVERTISEMENT_DOWNLOADABLE = 'advertisement_downloadable',
  FREE_DOWNLOADABLE = 'free_downloadable',
  FREE = 'free',
  ADVERTISEMENT = 'advertisement'
}
//Below 2 enums are used only for Kraken
export enum LOGIN_STATUS {
  LOGGEDIN = 'loggedin',
  GUEST = 'guest'
}
export enum MEMBERSHIP_TYPES {
  AVOD = 'avod',
  SVOD = 'svod'
}

export enum DEVICE_TYPES {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
  TABLET = 'tablet'
}

export enum DEVICE_OS {
  ANDRIOD = 'android',
  IOS = 'IOS',
  WEB = 'web'
}

export enum TVOD_PURCHASE_STATUS {
  ACTIVE = 'Active',
  EXPIRED = 'Expired'
}

export enum ASSET_SUBTYPE {
  VIDEO = 'video',
  KIDS = 'kids',
  MUSIC = 'music',
  NEWS = 'news',
  MOVIE = 'movie',
  SPORTS = 'sports',
  TV_SHOW = 'tvshow',
  DEFAULT = 'default',
  ORIGINALS = 'original',
  TRAILER = 'trailer',
  EPISDOE = 'episode',
  PREVIEW = 'preview',
  WEBISODE = 'webisode',
  CLIP = 'clip',
  PROMO = 'promo',
  MOBISODE = 'mobisode',
  WEEKINSHORT = 'weekinshort',
  SPORTS_VOD = 'sports_vod'
}
export enum USER_TYPES {
  PREMIUM = 'premium',
  GUEST = 'guest',
  REGISTER = 'register'
}

export enum TAGS {
  MOVIES = 'movies',
  TV_SHOWS = 'tvshows',
  WEBSERIES = 'webseries',
  CRICKET = 'cricket',
  ILT20 = 'ILT20'
}

export enum GENRES {
  KIDS = 'Kids',
  KID = 'Kid',
  EDUCATION = 'Education',
  ROMANCE = 'romance'
}

export enum KEY_CODES {
  ENTER = 'Enter',
  ARROW_UP = 'ArrowUp',
  ARROW_DOWN = 'ArrowDown'
}
export enum ExternalLinkEnums {
  WEB_VIEW = 'web_view',
  INTERNAL_LINK = 'internal_link',
  EXTERNAL_LINK = 'external_link'
}
export const USE_SLUG = process.env.NEXT_PUBLIC_USE_SLUG === 'true';

export enum OFFERS_DATA {
  AUTO_SUGGETS = 'auto-suggest',
  RECENT_SEARCH_FLAG = 'recentSearchFlag',
  TOP_SEARCH = 'top-search',
  SEARCH_QUERY_LENGTH = 'all_config_minimum_search_text_length'
}

export enum DEVICE_PLATFORM {
  MOBILE_WEB = 'mobile-web'
}

export enum API_LIMIT {
  TEN = 10
}
